import React from 'react';

import Framework from "@beardeddevops/react.framework";
import FeEstimates from "../../../../../components/Containers/FeEstimates";
import Tickers from "../../../../../components/Parts/Tickers";

const breadcrumbStatic = [{
	name: 'Managers',
	url: '/managers',
	icon: 'dashboard'
}];

export default class FeEstimatesContainer extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<FeEstimates history={history} />
				<div style={{display: 'flex', flexDirection: 'column'}}>
					<Tickers.HiringTicker/>
					<Tickers.HelpdeskTicker/>
					<Tickers.DispatchTicker/>
				</div>
			</div>
		)
	}
}